import { render } from "./Massimario.vue?vue&type=template&id=29c76d3c"
import script from "./Massimario.vue?vue&type=script&lang=ts"
export * from "./Massimario.vue?vue&type=script&lang=ts"
script.render = render

export default script